<script setup lang="ts">
const runtimeConfig = useRuntimeConfig()
const { params, path } = useRoute()
const store = useCmsStore()
await store.init({ id: params.id, url: path })
const { name, content, metaTitle, metaDescription } = storeToRefs(store)
useHead({
  titleTemplate: `${metaTitle.value} - %s`,
  meta: [
    { name: 'description', content: metaDescription.value },
    { name: 'robots', content: 'index,follow' }
  ],
  link: [
    { rel: 'canonical', href: `${runtimeConfig.public.baseUrl}${path}` }
  ]
})
</script>

<template>
  <div class="container mx-auto">
    <Breadcrumbs :breadcrumbs="[{ name }]"
    />
    <div v-html="content" class="format-html mb-[50px]" />
  </div>
</template>
